module.exports = __webpack_public_path__ + "static/clutter-1-ab5f41e22d3dce3319b8b3a2dd6774f6.jpg";